import * as React from "react";

import { SxProps, Typography, alpha, useTheme } from "@mui/material";
import { alpha as MuiAlpha } from "@mui/material"
interface ITagProps {
  title: string;
  color?: string;
  sxProps?: SxProps;
}

const Tag: React.FC<ITagProps> = ({ title, color, sxProps }) => {
  // Getting mui theme
  const theme = useTheme();
  // color tag
  let bgcolorTag: any;
  // color text
  let textColor: any;
  switch (color) {
    case "seeding":
    case "success":
      bgcolorTag = theme.palette.success.main;
      textColor = (t) => t.palette.common.white;
      break;

    case "published":
      bgcolorTag = '#a6e0ff';
      textColor = (t) => t.palette.common.white
      break
    case "soon":
      bgcolorTag = '#5b738b';
      textColor = (t) => t.palette.common.white
      break

    case "info":
    case "pending":
      bgcolorTag = alpha(theme.palette.info.main, 0.2);
      textColor = theme.palette.info.main;
      break;
    case "verified":
      textColor = theme.palette.success.main
      bgcolorTag = MuiAlpha(theme.palette.success.light, 0.2)
      break;
    case "gateway-pending":
      textColor = theme.palette.warning.main
      bgcolorTag = MuiAlpha(theme.palette.warning.main, 0.2)
      break
    case "payback-pending":
      textColor = theme.palette.warning.main
      bgcolorTag = MuiAlpha(theme.palette.warning.main, 0.2)
      break
    case "warning":
      textColor = theme.palette.warning.main
      bgcolorTag = MuiAlpha(theme.palette.warning.light, 0.2)
      break;
    case "rejected":
    case "suspended":
      bgcolorTag = alpha(theme.palette.error.main, 0.2);
      textColor = theme.palette.error.main;
      break;
    case "Enabled":
      textColor = alpha
        ? theme.palette.success.main
        : theme.palette.common.white
      bgcolorTag = MuiAlpha(theme.palette.success.main, 0.12)
      // textStatus = label || t("common:enabled")
      break

    default:
      bgcolorTag = theme.palette.primary.main;
      textColor = (t) => t.palette.common.white;
      break;
  }
  return (
    <Typography
      variant="extraSmallMedium"
      sx={{
        background: bgcolorTag,
        color: textColor,
        px: 1.5,
        py: 0.7,
        height: "fit-content",
        lineHeight: "20px !important",
        borderRadius: 10,
        whiteSpace: "nowrap",
        ...sxProps,
      }}
    >
      {title}
    </Typography>
  );
};

export default Tag;

